module.exports = __webpack_public_path__ + "img/banner-item2.a707a9dd.png";